<!--
 * @Author: fengjiahua fenjiahua@qq.com
 * @Date: 2024-01-24 10:05:36
 * @LastEditors: fengjiahua fenjiahua@qq.com
 * @LastEditTime: 2024-08-23 15:02:17
 * @FilePath: \qctsw-vue\packages\app\src\pages\news\components\Banner.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<script setup lang='ts'>
import { APP_ROUTER, checkLink, imageTransform } from '@qctsw/common'
import type { HomeBannerData } from '@/server/types'
import { AD_KEY } from '~/server/types'
import adStore from '@/stores/ad'

const _props = withDefaults(defineProps<{
  bannerData?: Omit<HomeBannerData, 'complain'>
}>(), {})

const { adList } = storeToRefs(adStore())
const adData = computed(() => adList.value.get(AD_KEY.B1) || [])
</script>

<template>
  <div v-if="bannerData" class="flex items-start">
    <NCarousel
      show-arrow dot-type="line" effect="fade"
      :default-index="0" :autoplay="true"
      class="flex-shrink-0 h-90 w-162.5 rounded-md mr-sm bg-slate-1"
    >
      <NuxtLink
        v-for="item, index in adData" :key="index"
        class="flex items-center justify-end h-full relative"
        :to="item.linkUrl"
      >
        <img
          class="h-full w-full object-cover"
          :alt="item.title"
          :src="imageTransform(item.imgUrl, { width: 975, height: 540, format: 'jpeg' })"
        >
        <h3 class="title">
          {{ item.title }}
        </h3>
      </NuxtLink>
      <!-- <BaseAd v-if="useAd(AD_KEY.B1)" :ad-key="AD_KEY.B1" :img-height="540" :img-width="975" body-class="my-0" /> -->
      <!-- TODO:AD_B1 -->
      <NuxtLink
        v-for="item, index in bannerData.bannres" :key="index"
        class="flex items-center justify-end h-full relative"
        :to="checkLink(item.link, APP_ROUTER.newsDetail(item.id))"
      >
        <img
          class="h-full w-full object-cover"
          :alt="item.title"
          :src="imageTransform(item.coverImgUrl, { width: 975, height: 540, format: 'jpeg' })"
        >
        <h3 class="title">
          {{ item.title }}
        </h3>
      </NuxtLink>
    </NCarousel>
    <div v-if="bannerData.articles" class="flex-grow min-w-0 text-4">
      <NuxtLink
        v-for="(v, i) in bannerData.articles.slice(0, 12)" :key="i"
        :to="checkLink(v.link, APP_ROUTER.newsDetail(v.id))"
        class="block truncate text-4.25  mb-1.25 last:mb-0 hover:text-orange-6 hover:text-orange-6)"
      >
        {{ v.title }}
      </NuxtLink>
    </div>
  </div>
</template>

<style lang='scss' scoped>
@import url('@/pages/index/components/banner.scss');
</style>
